import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";

import type { UserListItemDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { NameLinkCell } from "Shared/NameLinkCell";

const columnHelper = createColumnHelper<UserListItemDto>();

export const USERS_SORTABLE_COLUMNS = ["firstName", "login"] as const;

const isSortable = (id: string) =>
  (USERS_SORTABLE_COLUMNS as readonly string[]).includes(id);

export function useUsersTableColumns() {
  const { t } = useResource();

  return useMemo(
    () => [
      columnHelper.accessor("firstName", {
        header: t(Resources.Users.Name),
        enableSorting: isSortable("firstName"),
        cell: (info) => (
          <NameLinkCell
            path={AppRouting.UserDetail.path(info.row.original.userID)}
          >
            {`${info.getValue()} ${info.row.original.lastName}`}
          </NameLinkCell>
        ),
      }),
      columnHelper.accessor("login", {
        header: t(Resources.Users.Login),
        enableSorting: isSortable("login"),
        cell: (info) => info.getValue(),
      }),
    ],
    [t],
  );
}
